<template>
  <div class="container">
    <h3 class="title">Podaj objawy/Dolegliwości</h3>
    <div class="btn-group">
      <button type="button" class="btn" :style="{ background: $color }" @click="btnHandler('goraczka')">Gorączka</button>
      <button type="button" class="btn" :style="{ background: $color }" @click="btnHandler('kaszel')">Kaszel</button>
    </div>
    <div class="btn-group">
      <button type="button" class="btn" :style="{ background: $color }" @click="btnHandler('gardlo')">Ból gardła</button>
      <button type="button" class="btn" :style="{ background: $color }" @click="btnHandler('glowa')">Ból głowy</button>
    </div>
    <div class="btn-group">
      <button type="button" class="btn" :style="{ background: $color }" @click="btnHandler('brzuch')">Ból brzucha</button>
      <button type="button" class="btn" :style="{ background: $color }" @click="btnHandler('biegunka')">Biegunka</button>
    </div>
    <div class="btn-group">
      <button type="button" class="btn full" :style="{ background: $color }" @click="btnHandler('inne')">Inne</button>
    </div>
    <modal name="date-modal" :width="500" class="date-modal">
      <button @click="$modal.hide('date-modal')" class="modal-close">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.5999 1.40002L7.9999 8.00002M1.3999 14.6L7.9999 8.00002M7.9999 8.00002L1.3999 1.40002M7.9999 8.00002L14.5999 14.6" :stroke="$color" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
      <h4 class="modal-subtitle">Podaj datę wystąpienia pierwszych objawów</h4>
      <datepicker monday-first :inline="true" v-model="date" calendar-class="calendar" :style="{ color: $color }"/>
      <div class="btn-group">
        <button type="button" class="btn" :style="{ background: $color }" @click="saveDate">Podaj dane</button>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js"
export default {
  name: "StepMedicalSymptoms",
  data () {
    return {
      date: null
    }
  },
  components: {
    Datepicker
  },
  methods: {
    ...mapMutations(['setStep', 'setUserData', 'setAssistanceStep']),
    btnHandler (Symptoms) {
      this.setUserData({ Symptoms })
      this.$modal.show('date-modal')
      // this.setAssistanceStep('additional')
    },
    saveDate () {
      const pad = (n) => {return (n<10? '0' :  '') + n}
      const dateFormatted = pad(this.date.getUTCDate()) + '-' + pad(this.date.getUTCMonth() + 1) + '-' + this.date.getUTCFullYear();
      this.setUserData( { OccurranceData: dateFormatted })
      this.$modal.hide('date-modal')
      this.setAssistanceStep('wasDoctor')
      this.setStep({ index: 3, step: { text: 'Dodatkowe uwagi', value: 'additional' }})
    }
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/assistance_steps/StepMedicalSymptoms.vue